module.exports = __webpack_public_path__ + "img/2_1-industriale-fabbrica_a-0.dd062f28.png";